import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { NewsletterPopupT } from "./newsletter-popup";
import { NewsletterPopupForm } from "./newsletter-popup-form";
import { NewsletterHeadlineWithParagraph } from "./NewsletterHeadlineWithParagraph";

export const NewsletterPopupSignUp: ReactTFC<{
  t: NewsletterPopupT;
  links: { termsAndConditions: string; privacyPolicy: string };
  newsletterSignUp: (email: string) => Promise<unknown>;
}> = props => {
  return (
    <>
      <NewsletterHeadlineWithParagraph headline={props.t("emoHeadline")} paragraph={props.t("seoHeadline")} />

      <NewsletterPopupForm newsletterSignUp={props.newsletterSignUp} t={props.t} links={props.links} />
    </>
  );
};


